namespace TabAurous.Purchase {
    export namespace PurchaseItemsService {
        export const baseUrl = 'Purchase/PurchaseItems';

        export declare function Create(request: Serenity.SaveRequest<PurchaseItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PurchaseItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetItemDetails(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ValidateReference(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CategoryList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubCategoryList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function KaratList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PurchaseItems/Create",
            Update = "Purchase/PurchaseItems/Update",
            Delete = "Purchase/PurchaseItems/Delete",
            Retrieve = "Purchase/PurchaseItems/Retrieve",
            List = "Purchase/PurchaseItems/List",
            CustomList = "Purchase/PurchaseItems/CustomList",
            GetItemDetails = "Purchase/PurchaseItems/GetItemDetails",
            ValidateReference = "Purchase/PurchaseItems/ValidateReference",
            PartyList = "Purchase/PurchaseItems/PartyList",
            ProductList = "Purchase/PurchaseItems/ProductList",
            CategoryList = "Purchase/PurchaseItems/CategoryList",
            SubCategoryList = "Purchase/PurchaseItems/SubCategoryList",
            KaratList = "Purchase/PurchaseItems/KaratList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'GetItemDetails', 
            'ValidateReference', 
            'PartyList', 
            'ProductList', 
            'CategoryList', 
            'SubCategoryList', 
            'KaratList'
        ].forEach(x => {
            (<any>PurchaseItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
